import { useNavigate } from "react-router-dom";
import Layout4Register from "components/layout/Layout4Register";
import UtilClass from "api_ref/UtilClass";
import Css from './Register.module.css'
import React, { useEffect } from "react";
import HeadTrial from "../home/HeadTrial bnk";
import ScrollBackToTop from "components/pages/manual/ScrollBackToTop";
import LayoutLandingPage from "components/layout/LayoutLandingPageV3";

function Termsofuse() {
    const util = new UtilClass();
    const navigate = useNavigate();

    const handleRegister = (event) => {
        navigate('/register');
    }

    const handleATSPotral = (event) => {
        window.open(process.env.REACT_APP_ATS_POTAL, '_blank');
    }

    const handleFreeRegister = (event) => {
        //---- save period = 1 = month , package free id = 1;
        util.setCookie('period_id', 1, 1);
        util.setCookie('package_id', 1, 1);
        navigate('/register');
    }
    const handleLogin = (event) => {
        navigate('/login');
    }

    useEffect(() => {
       window.scrollTo(0, 0);
    }, [])

    return (
        <LayoutLandingPage  >
            <div className="container m-auto">
                <ScrollBackToTop/>
                <div className={Css.TermsAndCondition + " mt-3 mb-3 p-5"}>
                    <h2>ข้อตกลงและเงื่อนไขการใช้บริการ (Terms and Conditions)</h2>

                    <h5 >1. คำนิยาม</h5>
                    <label className={Css.fontdefinition}>
                        “บริการ”
                    </label>
                    <label className="mb-3">
                        หมายถึง บริการที่เกี่ยวข้องกับ ISO Document Control as a Service (ISO DCaaS) ที่ให้บริการโดย Magic Software (Thailand) Corp., Ltd. บริการประกอบด้วย, แต่ไม่จำกัดเพียง, การให้บริการที่เกี่ยวกับระบบจัดการเอกสารคุณภาพ ที่ผู้ใช้บริการสามารถ จัดการและติดตามเอกสารตามมาตรฐาน ISO ผ่านทางแพลตฟอร์มออนไลน์ รวมถึงฟีเจอร์, ฟังก์ชัน, และความสามารถต่างๆ ที่มีในระบบ</label>
                    <label className={Css.fontdefinition}>
                        “ผู้ให้บริการ”
                    </label>
                    <label className="mb-3">
                        หมายถึง Magic Software (Thailand) Corp., Ltd., ซึ่งเป็นผู้ให้บริการระบบ ISO DCaaS และมีสำนักงานตั้งอยู่ที่ 9/68 ซอยรัชประชา ถนนรัชดาภิเษก แขวงจตุจักร เขตจตุจักร กรุงเทพมหานคร 10900                    
                    </label>
                    <label className={Css.fontdefinition}>
                        “ผู้ใช้บริการ”
                    </label><br/>
                    <label className="mb-3">
                        หมายถึง บุคคลธรรมดา, นิติบุคคล, หรือองค์กรที่ลงทะเบียนใช้บริการ
                    </label><br/>
                    <label className={Css.fontdefinition}>
                        “เอกสาร”
                    </label><br/>
                    <label className="mb-3">
                        หมายถึง ข้อมูล, รายงาน, แบบฟอร์ม, และเอกสารอื่น ๆ ที่ผู้ใช้บริการสร้าง, อัปโหลด, แชร์, หรือจัดเก็บในระบบของบริการ
                    </label><br/>
                    <label className={Css.fontdefinition}>
                        “ข้อมูลส่วนบุคคล”
                    </label><br/>
                    <label className="mb-3">
                        หมายถึง ข้อมูลที่สามารถใช้เพื่อระบุตัวตนของบุคคลธรรมดาที่เป็นผู้ใช้บริการหรือบุคคลที่สามอื่น ๆ ที่เข้าถึงหรือใช้บริการ
                    </label><br/>
                    <label className={Css.fontdefinition}>
                        “บัญชีผู้ใช้บริการ”
                    </label><br/>
                    <label className="mb-3">
                        หมายถึง บัญชีที่สร้างขึ้นโดยผู้ใช้บริการเพื่อเข้าถึงและใช้บริการ
                    </label><br/>
                    <label className={Css.fontdefinition}>
                        “นโยบายความเป็นส่วนตัว”
                    </label><br/>
                    <label className="mb-3">
                        หมายถึง นโยบายที่กำหนดเพื่อรักษาความเป็นส่วนตัวของข้อมูลส่วนบุคคลของผู้ใช้บริการ
                    </label><br/>
                    <label className={Css.fontdefinition}>
                        “เนื้อหา”
                    </label><br/>
                    <label >
                        หมายถึง ข้อมูล, ข้อความ, ภาพ, วิดีโอ, ลิงค์, หรือเอกสารอื่น ๆ ที่ผู้ใช้บริการสร้าง, อัปโหลด, แชร์, หรือจัดเก็บในระบบของบริการ
                    </label>

                    <h5>2. การให้บริการ</h5>
                    <p className={Css.fonttersofuse2}>
                        2.1 การให้บริการและแพ็กเกจ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        การให้บริการจะดำเนินการตามเงื่อนไขและข้อกำหนดที่ได้ระบุไว้ในแพ็กเกจที่ผู้ใช้บริการได้เลือก และตามรายละเอียดที่ปรากฏบนเว็บไซต์ของผู้ให้บริการ ผู้ให้บริการจะให้บริการตามที่ผู้ใช้บริการได้เลือกและตกลงไว้
                    </p>
                    <p className={Css.fonttersofuse}>
                        2.2	การเปลี่ยนแปลงแพ็กเกจการให้บริการ                    
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการสงวนสิทธิ์ในการปรับปรุง หรือเปลี่ยนแปลงแพ็กเกจการให้บริการ รวมถึงราคาค่าบริการได้ตลอดเวลา เพื่อให้สอดคล้องกับความต้องการและสภาพการณ์ที่เปลี่ยนแปลง การเปลี่ยนแปลงจะมีผลทันทีเมื่อได้ประกาศบนเว็บไซต์ และผู้ให้บริการจะแจ้งให้ผู้ใช้บริการทราบผ่านทางอีเมลหรือช่องทางอื่นๆ
                    </p>
                    <p className={Css.fonttersofuse}>
                        2.3 ข้อจำกัดการให้บริการ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        บริการมีเป้าหมายเพื่อให้ความสะดวกสบายและปลอดภัยในการจัดการข้อมูล แต่มีข้อจำกัดดังนี้:
                    </p>
                    <table>
                        <tr >
                            <td >
                                <p className={Css.textptermsofuse1}>ก)</p>
                            </td>
                            <td>
                                <label className={Css.texttable}> ผู้ให้บริการไม่ได้ให้คำปรึกษาทางด้านการจัดการข้อมูล และให้บริการเฉพาะเครื่องมือและซอฟต์แวร์เท่านั้น </label><br/>
                                <label className={Css.texttable1}> ผู้ใช้บริการควรปรึกษาผู้เชี่ยวชาญหากต้องการคำแนะนำหรือบริการทางด้านการจัดการข้อมูล</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.textptermsofuse1}>ข)</p>
                            </td>
                            <td>
                                <label className={Css.texttable}> ผู้ให้บริการไม่สามารถรับประกันความถูกต้อง ครบถ้วนของข้อมูลที่ผู้ใช้บริการนำเข้าสู่ระบบ การใช้บริการนี้ต้องอยู่</label><br/>
                                <label className={Css.texttable1}>ภายใต้ความรับผิดชอบของผู้ใช้บริการเท่านั้น</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.textptermsofuse1}>ค)</p>
                            </td>
                            <td>
                                <label className={Css.texttable}>ผู้ให้บริการไม่สามารถรับประกันความแม่นยำและความเสถียรของบริการในทุกรูปแบบ ข้อจำกัดทางเทคโนโลยีอาจ</label><br/>
                                <label className={Css.texttable1}>ส่งผลต่อความสามารถในการให้บริการ</label>
                            </td>
                        </tr>
                    </table>
                    <p className={Css.fonttersofuse}>
                        2.4 การระงับบริการ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการ อาจทำการระงับการให้บริการ, ไม่ว่าจะเป็นทั้งหมดหรือบางส่วน, เป็นการชั่วคราวตามความจำเป็นและดุลยพินิจ, โดยอาจเกิดจากเหตุผลต่างๆ ดังนี้:
                    </p>
                    <label className={Css.textptermsofuse1}>ก)</label>
                    <label className={Css.texttable1}>การบำรุงรักษาหรือปรับปรุงอุปกรณ์และ/หรือระบบที่จำเป็นสำหรับการให้บริการ</label><br/>
                    <label className={Css.textptermsofuse1}>ข)</label>
                    <label className={Css.texttable1}>การพบปัญหาทางเทคนิคหรือการทำงานที่อาจส่งผลกระทบต่อความปลอดภัยหรือประสิทธิภาพของบริการ</label><br/>
                    <label className={Css.textptermsofuse1}>ค)</label>
                    <label className={Css.texttable1}>เหตุสุดวิสัยหรือเหตุที่ไม่สามารถควบคุมหรือป้องกันได้, ที่อาจส่งผลกระทบต่อการให้บริการ</label><br/>
                    <label className={Css.textptermsofuse1}>ง)</label>
                    <label className={Css.texttable1}>การไม่ปฏิบัติตามข้อตกลงและเงื่อนไขที่ได้ระบุไว้ในข้อตกลงการให้บริการนี้</label><br/>
                    <p>
                        ในระหว่างระยะเวลาที่บริการถูกระงับ, ผู้ให้บริการ จะไม่มีความรับผิดชอบต่อผู้ใช้บริการหรือบุคคลที่สามใดๆ และจะไม่คืนค่าบริการสำหรับระยะเวลาที่บริการถูกระงับ
                    </p>
                    <p className={Css.fonttersofuse}>
                        2.5 การควบคุมการใช้
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการขอสงวนสิทธิ์ในการตรวจสอบ, ตรวจตรา, และควบคุมวิธีการที่ผู้ใช้ใช้บริการ, และขอสงวนสิทธิ์ในการใช้ดุลยพินิจของผู้ให้บริการเพื่อปฏิบัติตามข้อกำหนดและเงื่อนไขนี้.
                    </p>

                    <h5>3. การใช้บริการ</h5>
                    <p className={Css.fonttersofuse}>
                        3.1 การลงทะเบียน 
                    </p>
                    <p className={Css.textptermsofuse1}>
                        บุคคลหรือนิติบุคคลที่ประสงค์จะเข้าใช้บริการจำเป็นต้องดำเนินการลงทะเบียนผ่านทางเว็บไซต์ที่ได้รับการอนุมัติจากผู้ให้บริการ และมีหน้าที่ให้ข้อมูลที่ถูกต้องและเป็นปัจจุบัน โดยข้อมูลที่ให้ต้องไม่ทำให้เกิดความสับสนหรือความเข้าใจผิด ผู้ให้บริการมีสิทธิ์ปฏิเสธการสมัครในกรณีที่ข้อมูลไม่ครบถ้วนหรือไม่ถูกต้อง หรือมีเหตุผลที่สมควรที่จะปฏิเสธ โดยไม่จำเป็นต้องเปิดเผยหลักเกณฑ์การปฏิเสธ ทั้งนี้ ผู้ให้บริการจะดำเนินการตรวจสอบและยืนยันความถูกต้องของข้อมูลที่ได้รับ และผู้ให้บริการมีสิทธิ์ขอเอกสารหรือข้อมูลเพิ่มเติมเพื่อยืนยันตัวตนของผู้สมัคร ผู้สมัครจะต้องให้ความร่วมมือในการยืนยันข้อมูล ทั้งนี้เพื่อให้กระบวนการดำเนินไปอย่างมีประสิทธิภาพและถูกต้องตามกฎหมาย                    </p>
                    <p className={Css.fonttersofuse}>
                        3.2	การใช้บริการ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการต้องปฏิบัติตามข้อกำหนดและเงื่อนไขที่ผู้ให้บริการกำหนด และต้องใช้บริการอย่างมีความรับผิดชอบ ไม่ละเมิดหรือทำให้เสียหายต่อสิทธิ์ของผู้ให้บริการ หรือบุคคลที่สาม และต้องไม่ใช้บริการในการกระทำที่ผิดกฎหมาย
                    </p>
                    <p className={Css.fonttersofuse}>
                        3.3	บัญชีผู้ใช้งาน
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการต้องรักษาบัญชีผู้ใช้งานและรหัสผ่านให้มีความปลอดภัยและเป็นความลับ และจะต้องรับผิดชอบในกรณีที่มีบุคคลที่สามใช้รหัสผ่านโดยไม่ได้รับอนุญาตหรือโดยทุจริต ทั้งนี้ ผู้ให้บริการจะถือว่า การใช้รหัสผ่านเพื่อดำเนินการใด ๆ ผ่านบัญชีผู้ใช้งานเป็นการกระทำของผู้รับบริการ และผู้รับบริการต้องแจ้งผู้ให้บริการทันทีในกรณีที่มีการใช้บัญชีโดยบุคคลที่ไม่ได้รับอนุญาต เพื่อให้ผู้ให้บริการสามารถดำเนินมาตรการป้องกันและแก้ไขปัญหาได้ทันท่วงที
                    </p>
                    <p className={Css.fonttersofuse}>
                        3.4	การจำกัดการใช้
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการตกลงที่จะไม่ใช้บริการเพื่อวัตถุประสงค์ที่ผิดกฎหมาย, ละเมิด, หรือทำลายสิทธิของบุคคลที่สามหรือของผู้ให้บริการ.
                    </p>
                    <p className={Css.fonttersofuse}>
                        3.5	ความรับผิดชอบต่อข้อมูล
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการจะต้องรับผิดชอบแต่เพียงผู้เดียวต่อข้อมูล, เนื้อหา, รูปภาพ, หรือส่วนประกอบอื่นๆ ที่นำเข้าระบบเพื่อใช้บริการ (“ข้อมูลของผู้ใช้บริการ”) และต้องรับประกันว่าข้อมูลดังกล่าวมีความถูกต้อง, ครบถ้วน, และถูกต้องตามกฎหมายทุกประการ ในกรณีที่มีข้อพิพาทหรือคดีความที่เกี่ยวข้องกับข้อมูลของผู้ใช้บริการ, ผู้ใช้บริการต้องรับผิดชอบและปกป้องผู้ให้บริการจากความเสียหายและค่าใช้จ่ายทุกประการ                    </p>
                    <table>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>3.5.1 ข้อมูลต้องห้าม</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <label className={Css.texttable2}>ผู้ใช้บริการตกลงและยินยอมว่าจะไม่ส่ง, สร้าง, แชร์, หรือให้ข้อมูลใด ๆ ที่เข้าสู่ระบบของผู้ให้บริการ ซึ่งเป็นการ</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>ละเมิดกฎหมาย, หรืออาจก่อให้เกิดความเสียหายต่อผู้ให้บริการหรือผู้ใช้บริการคนอื่น ๆ ได้แก่:</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>3.5.2 ข้อมูลปลอมไม่ว่าทั้งหมดหรือบางส่วน</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ผู้ใช้บริการต้องไม่ส่ง, สร้าง, หรือแชร์ข้อมูลปลอมหรือข้อมูลเท็จในระบบของผู้ให้บริการในทุกกรณี ซึ่งรวมถึงการ</label><br/>
                                <label className={Css.texttable2}>ปลอมแปลง, แก้ไข, หรือเปลี่ยนแปลงข้อมูลด้วยจุดประสงค์เพื่อหลอกลวง, ทำให้เกิดความเข้าใจผิด, หรือสร้าง</label><br/>
                                <label className={Css.texttable2}>ความเสียหายต่อผู้ให้บริการหรือบุคคลที่สาม โดยไม่จำกัดเพียงการใช้ข้อมูลที่ไม่เป็นความจริง, ข้อมูลที่น่าสงสัยใน</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>ความถูกต้อง, หรือข้อมูลที่อาจนำไปสู่ความเข้าใจผิดหรือสร้างความสับสนในหมู่ผู้ใช้บริการคนอื่น ๆ หรือบุคคลที่สาม</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>3.5.3 ข้อมูลเท็จที่เป็นอันตรายต่อความมั่นคงของประเทศ</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ข้อมูลที่ส่งมาต้องไม่มีลักษณะที่นำไปสู่ความเสียหายต่อความมั่นคงของประเทศ, ก่อให้เกิดความตื่นตระหนกแก่</label><br/>
                                <label className={Css.texttable2}>ประชาชน, หรือเป็นข้อมูลที่เป็นความผิดเกี่ยวกับความมั่นคงแห่งราชอาณาจักร หรือความผิดเกี่ยวกับการก่อการ</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>ร้ายตามประมวลกฎหมายอาญา</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>3.5.4 ข้อมูลที่มีไวรัสคอมพิวเตอร์ หรือโค้ดที่อาจทำลายระบบ</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ข้อมูลหรือเนื้อหาที่ส่งมาต้องไม่มีไวรัสคอมพิวเตอร์, ชุดคำสั่ง, โค๊ดคอมพิวเตอร์, ไฟล์, หรือโปรแกรมที่ออกแบบมา</label><br/>
                                <label className={Css.texttable2}>เพื่อทำลาย, ทำให้การทำงานของคอมพิวเตอร์, ฮาร์ดแวร์, หรือซอฟแวร์หยุดชะงัก, จำกัดฟังก์ชั่นการทำงาน, หรือ</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>สร้างอันตรายต่อความปลอดภัยของระบบคอมพิวเตอร์ หรือระบบเน็ตเวิร์ค</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>3.5.5 ข้อมูลเอกสารใดที่ละเมิดต่อกฎหมาย</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ข้อมูลที่ส่งมาต้องไม่ละเมิดสิทธิส่วนบุคคล, ลิขสิทธิ์, สิทธิบัตร, เครื่องหมายการค้า, เครื่องหมายบริการ, ความลับ</label><br/>
                                <label className={Css.texttable2}>ทางการค้า, หรือสิทธิในทรัพย์สินทางปัญญาของบุคคลที่สาม และไม่สร้างผลกระทบหรือความเสียหายต่อผู้</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>ให้บริการหรือบุคคลอื่นใด</label>
                            </td>
                        </tr>

                    </table>
                    <p className={Css.fonttersofuse}>
                        3.6	การใช้งานโดยชอบด้วยกฎหมาย
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการต้องใช้บริการอย่างชอบด้วยกฎหมายและสุจริต และจะต้องไม่ใช้บริการเพื่อสนับสนุน, ส่งเสริม, หรือเกี่ยวข้องในกิจกรรมที่ผิดกฎหมาย, ขัดต่อศีลธรรม, หรือทำให้เสียหายต่อผู้ให้บริการหรือผู้ใช้บริการคนอื่น หากมีการตรวจพบการใช้บริการที่ไม่เหมาะสมหรือผิดกฎหมาย, ผู้ให้บริการขอสงวนสิทธิ์ในการยกเลิกบริการและ/หรือบัญชีของผู้ใช้บริการทันที, โดยไม่ต้องแจ้งให้ทราบล่วงหน้า, และไม่ต้องรับผิดชอบต่อความเสียหายใดๆ ทั้งสิ้น
                    </p>
                    <p className={Css.fonttersofuse}>
                        3.7	ข้อห้ามในการใช้บริการ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการตกลงที่จะไม่ใช้บริการในลักษณะใด ๆ ดังต่อไปนี้
                    </p>
                    <table>
                    <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>3.7.1 ปลอมแปลงหรือลอกเลียนผู้อื่น</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ผู้ใช้บริการต้องไม่ปลอมแปลงหรือลอกเลียนเป็นบุคคลอื่นหรือแสดงตนเป็นเจ้าหน้าที่, พนักงาน, ตัวแทน, หรือผู้รับ</label><br/>
                                <label className={Css.texttable2}>มอบอำนาจของผู้ให้บริการเพื่อแสวงหาผลประโยชน์ที่ไม่ชอบด้วยกฎหมายหรือทำให้บุคคลภายนอกเข้าใจว่า</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>กระทำการแทนผู้ให้บริการ</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>3.7.2 ปลอมแปลง, ตัดทอน, แก้ไข, หรือเปลี่ยนแปลงข้อมูล</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ผู้ใช้บริการต้องไม่ปลอมแปลง, ตัดทอน, แก้ไข, หรือเปลี่ยนแปลงข้อมูลใด ๆ ที่อาจทำให้ข้อความหรือเนื้อหา</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>ภายในระบบหรือเว็บไซต์เปลี่ยนแปลงไปจากเดิม</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>3.7.3 ใช้โปรแกรมดำเนินการกับระบบ</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ผู้ใช้บริการต้องไม่ใช้โปรแกรมดึงข้อมูล, การทำเหมืองข้อมูล, โรบอต, หรือเทคนิคการรวบรวมข้อมูลอื่น ๆ ในการดึง</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>ข้อมูลจากแพลตฟอร์มหรือเว็บไซต์โดยไม่ได้รับอนุญาต</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>3.7.4 พยายามเข้าถึงส่วนของเว็บไซต์และระบบที่ไม่ได้รับอนุญาต</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ผู้ใช้บริการต้องไม่พยายามหรือกระทำการใด ๆ เพื่อเข้าถึงส่วนของเว็บไซต์หรือระบบที่ไม่ได้รับอนุญาตหรือไม่ได้รับ</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>อนุญาตให้เข้าถึง</label>
                            </td>
                        </tr>
                    </table>
                    
                    <h5>4. ความปลอดภัยของข้อมูล</h5>
                    <p className={Css.fonttersofuse}>
                        4.1	การปกป้องข้อมูล
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการจะใช้มาตรการทางเทคนิคและการจัดการเพื่อปกป้องข้อมูลของผู้ใช้บริการต่อการเข้าถึง, การเปิดเผย, การเปลี่ยนแปลง, หรือการทำลายที่ไม่ได้รับอนุญาต โดยจะดำเนินการตรวจสอบและปรับปรุงมาตรการความปลอดภัยอย่างต่อเนื่อง
                    </p>
                    <p className={Css.fonttersofuse}>
                        4.2	การสำรองข้อมูล และการกู้ข้อมูล
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการจะดำเนินการสำรองข้อมูลของผู้ใช้บริการเพื่อป้องกันการสูญหายของข้อมูล และผู้ใช้บริการยังควรจะดำเนินการสำรองข้อมูลที่สำคัญและข้อมูลอื่น ๆ ที่เก็บอยู่ในบริการเพื่อป้องกันการสูญหายของข้อมูลและเพื่อความสะดวกในการกู้คืนข้อมูล
                    </p>
                    <p className={Css.fonttersofuse}>
                        4.3	การเปลี่ยนแปลงในนโยบายความปลอดภัยของข้อมูล
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการขอสงวนสิทธิ์ในการเปลี่ยนแปลงนโยบายความปลอดภัยนี้ได้ตลอดเวลาและจะแจ้งให้ผู้ใช้บริการทราบทางช่องทางต่าง ๆ ที่ผู้ให้บริการกำหนด
                    </p>
                    <p className={Css.fonttersofuse}>
                        4.4	การใช้ข้อมูล
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการจะใช้ข้อมูลของผู้ใช้บริการตามที่กำหนดไว้ในนโยบายความเป็นส่วนตัวและข้อกำหนดและเงื่อนไขนี้
                    </p>
              
                    <h5>5. ค่าธรรมเนียมและการชำระเงิน</h5>
                    <p>
                        ผู้ใช้บริการตกลงที่จะชำระค่าธรรมเนียมและค่าใช้จ่ายอื่น ๆ ที่เกี่ยวข้องกับการใช้บริการตามที่ผู้ให้บริการกำหนด.
                    </p>
                    <p className={Css.fonttersofuse}>
                        5.1	การงดเว้นค่าธรรมเนียมสำหรับการทดลองใช้บริการฟรี (Free Trial)
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการมีนโยบายให้บริการทดลองใช้ฟรีเป็นเวลา 30 วันสำหรับผู้ใช้บริการที่ลงทะเบียนครั้งแรก ในระหว่างระยะเวลาทดลองใช้นี้ ผู้ใช้บริการจะสามารถใช้งานฟีเจอร์และบริการทั้งหมดที่มีในแพ็คเกจที่เลือก หลังจากระยะเวลาทดลองใช้สิ้นสุดลง ผู้ใช้บริการที่ต้องการดำเนินการใช้บริการต่อจะต้องทำการเลือกแพ็คเกจและชำระเงินตามราคาที่กำหนด
                        หากผู้ใช้บริการตัดสินใจไม่ดำเนินการใช้บริการต่อ บัญชีผู้ใช้บริการจะถูกระงับการใช้งานและผู้ให้บริการมีสิทธิ์ไม่เก็บรักษาข้อมูลที่ได้รับระหว่างการทดลองใช้บริการ และไม่ต้องรับผิดชอบในความเสียหายที่อาจเกิดขึ้นจากการไม่เก็บรักษาข้อมูลดังกล่าว
                    </p>
                    <p className={Css.fonttersofuse}>
                        5.2	ค่าธรรมเนียมบริการ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการต้องชำระค่าธรรมเนียมในการใช้บริการตามที่ผู้ให้บริการกำหนดและประกาศไว้ในตารางค่าธรรมเนียมหรือหน้าเว็บไซต์ของผู้ให้บริการ หรือตามที่ได้ตกลงกันและได้รับการยืนยันเป็นลายลักษณ์อักษร การเปลี่ยนแปลงค่าธรรมเนียมจะถูกแจ้งให้ทราบล่วงหน้า 
                    </p>
                    <p className={Css.fonttersofuse}>
                        5.3	วิธีการชำระเงิน
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการสามารถชำระเงินผ่านช่องทางที่ผู้ให้บริการกำหนด ซึ่งอาจรวมถึงการโอนเงินผ่านธนาคาร, การชำระเงินด้วยบัตรเครดิต, หรือวิธีการชำระเงินอื่น ๆ ที่ได้รับการอนุมัติจากผู้ให้บริการ
                    </p>
                    <p className={Css.fonttersofuse}>
                        5.4	การเรียกเก็บเงิน
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการจะเรียกเก็บเงินตามรอบการเรียกเก็บเงินที่กำหนด และจะส่งใบแจ้งหนี้ให้ผู้ใช้บริการทางอีเมลหรือช่องทางการติดต่ออื่น ๆ ผู้ใช้บริการต้องชำระเงินภายในระยะเวลาที่กำหนดในใบแจ้งหนี้
                    </p>
                    <p className={Css.fonttersofuse}>
                        5.5	การเปลี่ยนแปลงค่าธรรมเนียม
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการสงวนสิทธิ์ในการปรับปรุงหรือเปลี่ยนแปลงค่าธรรมเนียมบริการได้ตลอดเวลา และจะแจ้งให้ผู้ใช้บริการทราบล่วงหน้า ผ่านทางอีเมลหรือช่องทางการติดต่ออื่น ๆ
                    </p>
                    <p className={Css.fonttersofuse}>
                        5.6	การยกเลิกบริการกรณีไม่ชำระค่าบริการ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการมีสิทธิ์ยกเลิกบริการหรือระงับบริการโดยไม่ต้องแจ้งให้ทราบล่วงหน้าหากผู้ใช้บริการไม่ชำระเงินตามกำหนด ข้อมูลทั้งหมดจะถูกลบออกจากระบบหลังจากการยกเลิกบริการตามที่ผู้ให้บริการ
                    </p>
                    <p className={Css.fonttersofuse}>
                        5.7	การคืนเงิน
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการจะไม่คืนเงินใด ๆ ที่ได้รับจากผู้ใช้บริการ ยกเว้นในกรณีที่ผู้ให้บริการตัดสินใจทำเช่นนั้นตามดุลยพินิจของผู้ให้บริการหรือตามที่กฎหมายกำหนด
                    </p>
                    <h5>6. การยกเลิกบริการ</h5>
                    <p className={Css.fonttersofuse}>
                        6.1	การยกเลิกโดยผู้ใช้บริการ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการ มีสิทธิ์ในการขอยกเลิกสัญญาบริการ โดยสามารถส่งคำขอยกเลิกสัญญาบริการไปยัง  ที่อยู่อีเมล isodcaas.support@magicsoftware.co.th และต้องยื่นคำขอก่อนสิ้นสุดระยะเวลาการใช้บริการ การเลิกสัญญาบริการจะมีผลในวันสุดท้ายของระยะเวลาการใช้บริการตามสัญญาบริการ หากผู้ใช้บริการประสงค์ที่จะเลิกสัญญาบริการให้มีผลทันที (ปิด Account ก่อนสิ้นสุดระยะเวลาการใช้บริการ) สามารถระบุในรายละเอียดคำขออยกเลิกสัญญาบริการ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        การแจ้งยกเลิกบริการจากผู้ใช้บริการควรปฏิบัติตามขั้นตอนและเงื่อนไขดังนี้เพื่อให้การยกเลิกบริการเป็นไปตามกระบวนการที่ถูกต้องและชัดเจน:
                    </p>
                    <p>
                        1. ช่องทางการแจ้ง: ผู้ใช้บริการสามารถแจ้งยกเลิกบริการผ่านทางหลายช่องทาง ได้แก่ อีเมล, โทรศัพท์, หรือผ่านทางหน้าเว็บไซต์ของผู้ให้บริการ โดยต้องใช้ชื่อผู้ใช้บริการและข้อมูลที่ได้ลงทะเบียนไว้เพื่อยืนยันตัวตน
                    </p>
                    <p>
                        2. ระยะเวลาแจ้งล่วงหน้า: ผู้ใช้บริการต้องแจ้งยกเลิกบริการล่วงหน้า ก่อนวันที่ต้องการให้บริการสิ้นสุด
                    </p>
                    <p>
                        3. เนื้อหาของการแจ้ง: การแจ้งยกเลิกควรประกอบด้วยเหตุผลในการยกเลิก, วันที่ต้องการให้บริการสิ้นสุด, และข้อมูลติดต่อกลับจากผู้ใช้บริการเพื่อให้ผู้ให้บริการสามารถติดต่อยืนยันการยกเลิกได้
                    </p>
                    <p>
                        4. การยืนยันการยกเลิก: หลังจากที่ผู้ให้บริการได้รับการแจ้งยกเลิก, ผู้ให้บริการจะส่งการยืนยันการรับทราบการยกเลิกผ่านทางอีเมลหรือช่องทางติดต่อที่ผู้ใช้บริการได้ระบุไว้
                    </p>
                    <p className={Css.fonttersofuse}>
                        6.2	การยกเลิกโดยผู้ให้บริการ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการขอสงวนสิทธิ์ในการยกเลิกบริการที่ผู้ใช้บริการใช้งานอยู่ในทุกเวลา หากผู้ให้บริการตรวจสอบแล้วพบว่าผู้ใช้บริการละเมิดข้อกำหนดและเงื่อนไขที่กำหนดไว้ หรือใช้บริการในลักษณะที่เป็นอันตรายต่อผู้ให้บริการหรือบุคคลที่สาม การยกเลิกสัญญาบริการจะถูกแจ้งให้ผู้ใช้บริการบริการทราบล่วงหน้า และจะให้โอกาสในการแก้ไขหรือปรับปรุงสถานการณ์ก่อนที่จะดำเนินการยกเลิกสัญญาบริการ โดยการยกเลิกบริการโดยผู้ให้บริการอาจเกิดขึ้นในหลายสถานการณ์ ได้แก่:
                    </p>
                    <label className={Css.textptermsofuse1}>ก)</label>
                    <label className={Css.texttable1}>ผู้ใช้บริการละเมิดเงื่อนไขการให้บริการ, นโยบายความเป็นส่วนตัว, หรือข้อกำหนดอื่น ๆ ที่ผู้ให้บริการกำหนด</label><br/>
                    <label className={Css.textptermsofuse1}>ข)</label>
                    <label className={Css.texttable1}>ผู้ใช้บริการใช้บริการเพื่อการทำผิดกฎหมายหรือการกระทำที่ไม่เหมาะสม</label><br/>
                    <label className={Css.textptermsofuse1}>ค)</label>
                    <label className={Css.texttable1}>ผู้ใช้บริการพยายามทำความเสียหายต่อระบบหรือข้อมูลของผู้ให้บริการหรือลูกค้าของผู้ให้บริการ</label><br/>
                    <label className={Css.textptermsofuse1}>ง)</label>
                    <label className={Css.texttable1}>ผู้ใช้บริการใช้บริการในลักษณะที่สร้างภาระหนักเกินไปต่อระบบหรือเครือข่ายของผู้ให้บริการ</label><br/>
                    <p>
                        ในบางกรณี, แม้ว่าบริการจะถูกยกเลิกแล้ว, ผู้ให้บริการอาจจำเป็นต้องเก็บรักษาข้อมูลบางประการของผู้ใช้บริการเพื่อปฏิบัติตามกฎหมาย, การสืบสวน, หรือการพิจารณาคดีที่เกี่ยวข้องกับการใช้บริการของผู้ใช้บริการ ผู้ให้บริการจะเก็บรักษาข้อมูลเท่าที่จำเป็นและตามที่กฎหมายกำหนด และจะไม่ใช้ข้อมูลนั้นในเชิงพาณิชย์หรือในวัตถุประสงค์อื่น ๆ ที่ไม่เกี่ยวข้องกับเหตุผลที่กล่าวมา.
                    </p>
                    <p className={Css.fonttersofuse}>
                        6.3	ผลกระทบหลังการยกเลิก
                    </p>
                    <p className={Css.textptermsofuse1}>
                        เมื่อบริการถูกยกเลิก, ผู้ใช้บริการจะไม่สามารถเข้าถึงหรือใช้งานบริการและข้อมูลที่เก็บอยู่ในบริการนั้น ๆ ได้อีกต่อไป นอกจากนี้, ข้อมูลทั้งหมดที่เกี่ยวข้องกับบัญชีผู้ใช้บริการจะถูกลบออกจากระบบของผู้ให้บริการ, ซึ่งรวมถึงข้อมูลส่วนตัว, ข้อมูลการใช้งาน, และข้อมูลที่สร้างขึ้นจากการใช้บริการ.
                    </p>
                    <p className={Css.fonttersofuse}>
                        6.4	การคืนเงิน
                    </p>
                    <table>
                    <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>6.4.1 นโยบายการคืนเงิน</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ผู้ให้บริการไม่มีนโยบายในการคืนเงินหลังจากที่บริการถูกยกเลิก ยกเว้นในกรณีที่ผู้ให้บริการตัดสินใจคืนเงินตาม</label><br/>
                                <label className={Css.texttable2}>ดุลยพินิจของผู้ให้บริการ หรือในกรณีที่บริการไม่สามารถให้บริการตามที่ประกาศไว้ หรือมีข้อผิดพลาดจากฝั่งของ</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>ผู้ให้บริการ</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>6.4.2 กรณีพิเศษสำหรับการคืนเงิน</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ผู้ให้บริการอาจพิจารณาการคืนเงินในกรณีพิเศษ ตามดุลยพินิจของผู้ให้บริการ หรือในกรณีที่บริการไม่สามารถ</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>ให้บริการตามที่ประกาศไว้ หรือมีข้อผิดพลาดจากฝั่งของผู้ให้บริการ</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>6.4.3 วิธีการคืนเงิน</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>การคืนเงินจะดำเนินการผ่านช่องทางการชำระเงินที่ใช้ในการซื้อบริการ ซึ่งอาจรวมถึงการโอนเงินผ่านธนาคาร, </label><br/>
                                <label className={`${Css.texttable2} mb-3`}>การคืนเงินผ่านบัตรเครดิต, หรือวิธีการอื่น ๆ ที่ผู้ให้บริการให้บริการ</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>6.4.4 การส่งคำร้องขอคืนเงิน</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ผู้ใช้บริการที่ต้องการขอคืนเงินต้องส่งคำร้องทางอีเมล์หรือช่องทางการติดต่ออื่น ๆ ที่ผู้ให้บริการกำหนด โดยระบุ</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>เหตุผลและหลักฐานที่เกี่ยวข้อง (ถ้ามี) ภายในระยะเวลาที่ผู้ให้บริการกำหนด</label>
                            </td>
                        </tr>
                        <tr >
                            <td >
                                <p className={Css.fonttersofuse3}>6.4.5 การติดต่อแจ้งผล</p>
                            </td>
                        </tr>
                        <tr >
                            <td>
                                <label className={Css.texttable2}>ผู้ให้บริการจะแจ้งผลการตัดสินใจเกี่ยวกับคำร้องขอคืนเงินผ่านทางอีเมล์หรือช่องทางการติดต่อที่ผู้ใช้บริการได้ให้</label><br/>
                                <label className={`${Css.texttable2} mb-3`}>ไว้ในการสมัครบริการ</label>
                            </td>
                        </tr>
                    </table>
                    <p className={Css.fonttersofuse}>
                        6.5	การยกเลิกและการสำรองข้อมูล
                    </p>
                    <p className={Css.textptermsofuse1}>
                        เมื่อการยกเลิกบริการเกิดขึ้น, บัญชีผู้ใช้บริการและข้อมูลทั้งหมดที่เกี่ยวข้องกับบัญชีนั้นจะถูกลบออกจากระบบของผู้ให้บริการ หลังจากวันที่การยกเลิกบริการมีผลบังคับใช้. การลบข้อมูลนี้เป็นการลบแบบถาวรและไม่สามารถกู้คืนได้ในทุกกรณี. ดังนั้น, ผู้ใช้บริการจึงควรทำการสำเนาสำรองข้อมูลที่สำคัญและต้องการเก็บไว้ก่อนทำการยกเลิกบริการเพื่อป้องกันการสูญหายของข้อมูล.ผู้ให้บริการขอแนะนำให้ผู้ใช้บริการตรวจสอบและยืนยันว่าข้อมูลทั้งหมดที่ต้องการเก็บไว้ได้ถูกสำรองอย่างถูกต้องและครบถ้วนก่อนที่จะแจ้งยกเลิกบริการ. นอกจากนี้, ผู้ใช้บริการควรตรวจสอบว่าไม่มีข้อมูลหรือการตั้งค่าใด ๆ ที่ต้องการจากบัญชีนี้อีกต่อไป เนื่องจากหลังจากการยกเลิกบริการและข้อมูลถูกลบ, ผู้ให้บริการจะไม่สามารถดำเนินการกู้คืนข้อมูลใด ๆ ให้กับผู้ใช้บริการได้. ผู้ให้บริการจะไม่รับผิดชอบในกรณีที่ข้อมูลถูกลบหรือไม่สามารถเข้าถึงได้เนื่องจากการยกเลิกบริการ.
                    </p>
                    <p className={Css.fonttersofuse}>
                        6.6	การยกเลิกและค่าใช้จ่าย
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ในกรณีที่บริการถูกยกเลิก, หากผู้ให้บริการตรวจสอบแล้วพบว่าผู้ใช้บริการมีค่าปรับหรือค้างชำระค่าบริการ, ผู้ใช้บริการต้องชำระค่าใช้จ่ายที่ค้างชำระทั้งหมดกับผู้ให้บริการทันทีเพื่อป้องกันการเรียกเก็บค่าปรับและ/หรือดอกเบี้ยตามที่กฎหมายอนุญาต และในกรณีที่ผู้ใช้บริการไม่ชำระค่าใช้จ่ายที่ค้างชำระภายในระยะเวลาที่ผู้ให้บริการกำหนด, ผู้ให้บริการจะดำเนินการทางกฎหมายเพื่อเรียกเก็บค่าใช้จ่ายที่ค้างชำระนั้น และผู้ใช้บริการจะต้องรับผิดชอบในค่าใช้จ่ายทั้งหมดที่เกิดขึ้นจากการดำเนินการทางกฎหมายและค่าธรรมเนียมอื่น ๆ ที่เกี่ยวข้อง
                    </p>
                    <p className={Css.fonttersofuse}>
                        6.7	การยกเลิกและความรับผิดชอบ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        เมื่อการยกเลิกบริการเกิดขึ้น, ไม่ว่าจะเป็นจากฝ่ายผู้ใช้บริการหรือฝ่ายผู้ให้บริการ, ความรับผิดชอบที่เกิดขึ้นจากการใช้บริการก่อนหน้านั้นยังคงอยู่. ผู้ใช้บริการต้องรับผิดชอบในทุก ๆ กรณีที่เกี่ยวข้องกับการใช้บริการของตนเอง, รวมถึงการใช้บริการที่ไม่เหมาะสม, การละเมิดข้อมูล, หรือการกระทำใด ๆ ที่ทำให้เกิดความเสียหายต่อผู้ให้บริการหรือบุคคลที่สาม. นอกจากนี้, ในกรณีที่ผู้ให้บริการได้รับคำร้องเรียน, การดำเนินคดี, หรือการเรียกร้องค่าเสียหายใด ๆ ที่เกิดขึ้นจากการใช้บริการของผู้ใช้บริการ, ผู้ใช้บริการต้องรับผิดชอบและชดใช้ค่าใช้จ่ายทั้งหมดที่เกี่ยวข้อง, รวมถึงค่าทนายความ, ค่าธรรมเนียม, และค่าเสียหายที่ผู้ให้บริการได้รับ. การยกเลิกบริการไม่ได้ยกเลิกหรือยกเว้นความรับผิดชอบที่อาจเกิดขึ้นจากการใช้บริการก่อนหน้านั้น.
                    </p>

                    <h5>7. การเปลี่ยนแปลงเงื่อนไขการให้บริการ</h5>
                    <p>
                        ผู้ให้บริการได้กำหนดเงื่อนไขการใช้บริการ เพื่อให้ข้อมูลเกี่ยวกับข้อกำหนดและเงื่อนไขในการใช้บริการระหว่างผู้ใช้บริการและผู้ให้บริการเอง ทั้งนี้ ไม่ว่าจะเป็นในขณะใด ผู้ให้บริการสามารถทำการแก้ไขหรือปรับปรุงข้อกำหนดและเงื่อนไขต่าง ๆ ที่ปรากฎในเอกสารนี้ได้ตามความเหมาะสมและความจำเป็น นอกจากนี้ ผู้ให้บริการขอสงวนสิทธิ์ในการเปลี่ยนแปลงรายละเอียดข้อกำหนดและเงื่อนไขต่าง ๆ ในเอกสารนี้ได้ โดยไม่ต้องทำการแจ้งให้ผู้ใช้บริการทราบล่วงหน้า ดังนั้น จึงเป็นความรับผิดชอบของผู้ใช้บริการที่จะต้องตรวจสอบรายละเอียดข้อกำหนดและเงื่อนไขในการใช้บริการอย่างสม่ำเสมอเพื่อให้สอดคล้องกับการใช้บริการที่เป็นปัจจุบัน
                    </p>

                    <h5>8. ข้อจำกัดความรับผิดชอบ</h5>
                    <p className={Css.fonttersofuse}>
                        8.1	ข้อจำกัดความรับผิดทั่วไป
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการมุ่งพยายามให้บริการอย่างมีประสิทธิภาพ, แต่บริการเป็นไปตามสภาพปัจจุบัน และไม่มีการรับประกันว่าบริการจะปราศจากข้อบกพร่อง เช่น ความเสถียร, ความเชื่อถือได้, ความแม่นยำ, ความสมบูรณ์, ประสิทธิผล, ความเหมาะสมตามวัตถุประสงค์, ความปลอดภัย, ข้อผิดพลาด, ข้อบกพร่องของคอมพิวเตอร์ หรือไวรัส
                    </p>
                    <p className={Css.fonttersofuse}>
                        8.2	ข้อจำกัดความเสียหาย
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการไม่รับผิดชอบต่อความเสียหายใด ๆ ที่เกิดขึ้นจากการใช้บริการ หรือจากความบกพร่องในการใช้บริการ ยกเว้นในกรณีที่ความเสียหายเกิดขึ้นจากการจงใจหรือความประมาทอันร้ายแรงจากฝ่ายผู้ให้บริการเอง ในกรณีนี้เท่านั้น ผู้ให้บริการจะรับผิดชอบต่อค่าเสียหายที่แท้จริงที่เกิดขึ้นแก่ผู้ใช้บริการ โดยไม่เกินอัตราค่าบริการรายปีหรือตามอัตราที่ผู้ให้บริการได้รับชำระจากผู้ใช้บริการในปีที่เกิดเหตุ อย่างไรก็ตาม ผู้ให้บริการไม่รับผิดต่อความสูญหายของผลกำไร การใช้ประโยชน์ ข้อมูล หรือความเสียหายที่ไม่เป็นรูปธรรมอื่น ๆ ที่เกิดขึ้นจากการใช้บริการซึ่งไม่ใช่ความเสียหายโดยตรง.
                    </p>

                    <h5>9. ข้อตกลงอื่น ๆ</h5>
                    <p className={Css.fonttersofuse}>
                        9.1	ข้อตกลงทั้งหมด
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ข้อตกลงนี้, รวมทั้งนโยบายและเงื่อนไขที่เกี่ยวข้อง, จะเป็นข้อตกลงครบถ้วนระหว่างผู้ใช้บริการและผู้ให้บริการ และจะยกเลิกและแทนที่ข้อตกลงหรือความเข้าใจใด ๆ ที่เกิดขึ้นก่อนหน้า, ไม่ว่าจะเป็นแบบเป็นลายลักษณ์อักษรหรือไม่. ข้อตกลงนี้จะมีผลเมื่อผู้ใช้บริการเริ่มใช้บริการ.
                    </p>
                    <p className={Css.fonttersofuse}>
                        9.2	การสละสิทธิ์
                    </p>
                    <p className={Css.textptermsofuse1}>
                        การที่ผู้ให้บริการไม่ดำเนินการเมื่อมีการละเมิดข้อตกลงนี้ไม่ถือว่าเป็นการสละสิทธิ์ในการดำเนินการเรื่องการละเมิดนั้นหรือการละเมิดในอนาคต ทั้งนี้ การสละสิทธิ์จะต้องเป็นลายลักษณ์อักษรและได้รับการยอมรับจากฝ่ายที่ถูกสละสิทธิ์นั้น ๆ การสละสิทธิ์ของข้อตกลงใด ๆ จากฝ่ายใด ๆ จะไม่ถือว่าเป็นการสละสิทธิ์ของข้อตกลงอื่น ๆ หรือข้อตกลงนั้นในอนาคต
                    </p>
                    <p className={Css.fonttersofuse}>
                        9.3	ความล่าช้า
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ให้บริการและผู้ใช้บริการจะไม่ต้องรับผิดชอบต่อความเสียหายที่เกิดขึ้นจากความล่าช้าหรือความล้มเหลวในการปฏิบัติตามข้อตกลงนี้ หากความล่าช้าหรือความล้มเหลวนั้นเกิดจากสาเหตุที่อยู่นอกเหนือการควบคุมที่เหมาะสมของฝ่ายนั้น ๆ ซึ่งอาจรวมถึงภัยธรรมชาติ, การปฏิวัติ, การก่อการร้าย, การกระทำของรัฐบาลหรือหน่วยงานระหว่างประเทศ, หรือการล้มเหลวของอินเทอร์เน็ต แต่ข้อยกเว้นนี้จะไม่ใช้บังคับในกรณีที่มีข้อผูกมัดที่ต้องมีการชำระเงินตามข้อตกลงนี้
                    </p>
                    <p className={Css.fonttersofuse}>
                        9.4	การโอนสิทธิ์
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ผู้ใช้บริการไม่สามารถโอนหรือมอบหมายสิทธิ์และหน้าที่ตามข้อตกลงนี้ให้กับบุคคลอื่นโดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษรจากผู้ให้บริการ หากผู้ใช้บริการพยายามทำเช่นนั้น การโอนหรือมอบหมายจะไม่มีผลบังคับใช้ต่อผู้ให้บริการ และผู้ให้บริการอาจปฏิเสธการโอนหรือมอบหมายนั้นได้ตามความเหมาะสม.
                    </p>
                    <p className={Css.fonttersofuse}>
                        9.5	กฎหมายที่ใช้บังคับ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        ข้อตกลงนี้จะถูกตีความและบังคับใช้ตามกฎหมายของประเทศไทย หากเกิดข้อพิพาทที่เกี่ยวข้องกับข้อตกลงนี้, ผู้ให้บริการและผู้ใช้บริการจะพยายามทำการประนีประนอมเพื่อแก้ไขข้อพิพาทนั้นในลักษณะที่เป็นมิตรและสมานฉันท์ หากข้อพิพาทไม่สามารถแก้ไขได้ด้วยการเจรจา, ข้อพิพาทดังกล่าวจะถูกนำไปตัดสินที่ศาลที่มีเขตอำนาจในประเทศไทย
                    </p>
                    <p className={Css.fonttersofuse}>
                        9.6	การเป็นโมฆียะ
                    </p>
                    <p className={Css.textptermsofuse1}>
                        หากมีข้อกำหนดใด ๆ ในข้อตกลงนี้ถูกพิสูจน์ว่าเป็นโมฆียะหรือไม่สามารถบังคับใช้ได้ตามกฎหมาย, ข้อกำหนดนั้น ๆ จะถูกแยกตัดออกจากข้อตกลงนี้ และข้อกำหนดที่เหลือจะยังคงมีผลบังคับใช้ต่อไป โดยไม่ได้มีผลกระทบต่อความสมบูรณ์และความถูกต้องของข้อตกลงทั้งหมดนี้ในทางกฎหมาย.
                    </p>
                    <p className={Css.fonttersofuse}>
                        9.7	สิทธิของบุคคลที่สาม
                    </p>
                    <p className={`${Css.textptermsofuse1} mb-5`}>
                        ข้อตกลงนี้เป็นสิทธิ์และหน้าที่ระหว่างผู้ใช้บริการและผู้ให้บริการเท่านั้น และไม่มีบุคคลที่สามที่มีสิทธิ์, หน้าที่, หรือสถานะในการบังคับใช้ข้อตกลงนี้ หรือสิทธิ์ใด ๆ ตามข้อตกลงนี้ ยกเว้นในกรณีที่ข้อตกลงนี้มีการระบุไว้อย่างชัดเจนว่ามีสิทธิ์ที่จะทำเช่นนั้น. นอกจากนี้, ไม่มีส่วนหนึ่งของข้อตกลงนี้ที่จะสร้างสิทธิ์ใด ๆ หรือประโยชน์ใด ๆ ให้แก่บุคคลที่สาม หรือทำให้บุคคลที่สามมีสิทธิ์ในการเรียกร้องหรือบังคับใช้ข้อตกลงนี้.
                    </p>
                    <p className={Css.fonttersofuse1}>
                        ประกาศเมื่อวันที่ 9 ตุลาคม 2566
                    </p>
                </div>

            </div>
        </LayoutLandingPage>
    )
}
export default Termsofuse;